module.exports = __webpack_public_path__ + "img/check.8751f540.svg";